module.exports = __webpack_public_path__ + "static/media/cambridge.0bcfd6b1.png";